/**
 * Firebase config for the vaiu buyer app (vaiu-eur).
 * Matches api.vaiu.io PUBLIC_SETTINGS.google.firebaseConfig.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyBi4Xqzq8poW2diiujswjIIqSRBBSkfgm4',
  authDomain: 'vaiu-eur.firebaseapp.com',
  projectId: 'vaiu-eur',
  storageBucket: 'vaiu-eur.appspot.com',
  messagingSenderId: '830362232707',
  appId: '1:830362232707:web:0819516a667edf5587f8b6',
  measurementId: 'G-8KMK9FHY60',
} as const;

/**
 * Web Push VAPID public key (Firebase Console → Cloud Messaging → Web Push certificates).
 * Override at build time with VITE_FCM_VAPID_KEY when rotating keys.
 */
export const FCM_VAPID_KEY =
  import.meta.env.VITE_FCM_VAPID_KEY ||
  'BLE0mbcDp6giHn_wTDdv_2iHTHnmt3Yeqv-I8fCPSQrPDkSykUDVqyIHQiu3jdRyx03p_ieYbFeCjgXovNjYWJk';
